import { graphql } from 'react-relay';
import get from 'lodash.get';

import { getLocalRecentHistoryList } from './getLocalRecentHistory';
import { MAX_RECENTLY_VIEWED_ITEMS } from './recentHistoryConstants';

export const getRecentHistoryList = ({
    itemId = '',
    maxItems,
    recentHistoryItems = [],
    isClient,
}) => {
    if (!isClient) {
        return [];
    }

    const maxRecentlyViewedItems = maxItems || MAX_RECENTLY_VIEWED_ITEMS;

    // get local recently viewed items
    const localRecentItems = getLocalRecentHistoryList(null, maxRecentlyViewedItems).reverse();

    // format passed in recently viewed items to match items in local storage
    const formattedRecentHistoryItems = recentHistoryItems
        .filter(({ item }) => Boolean(item) && item.title && item.pdpURL && item.firstPhotoWebPath) // items should  have title, link, and image otherwise it's NOT AN ITEM!! >:-(
        .map(({ item, eventDate }) => ({
            category: item.categoryPath,
            contemporaryTrackingString: item.contemporaryTrackingString,
            dealerPk: get(item, 'seller.serviceId'),
            itemBrowseUrl: item.browseUrl,
            itemCategoryCode: item.categoryCode,
            itemId: item.serviceId,
            itemImageUrl: item.firstPhotoWebPath,
            itemPdpUrl: item.pdpURL,
            itemTitle: item.title,
            lastVisited: eventDate,
            timestamp: new Date(eventDate).getTime(),
        }));

    // combine local items with passed in recently viewed items
    const recentItems = [...localRecentItems, ...formattedRecentHistoryItems];

    const recentItemsMap = {};
    const uniqueRecentItems = [];

    // De-dupe recent items
    recentItems.forEach(recentItem => {
        const recentItemId = recentItem.itemId || recentItem.item_id;
        const isCurrentItem = recentItemId === itemId;
        if (!recentItemsMap[recentItem.itemId] && !isCurrentItem) {
            recentItemsMap[recentItem.itemId] = true;
            uniqueRecentItems.push(recentItem);
        }
    });

    // sort all recent items by date (recency)
    const sortedUniqueRecentItems = uniqueRecentItems.sort(
        (a, b) => new Date(b.lastVisited) - new Date(a.lastVisited)
    );

    // return max number of most recent items
    return sortedUniqueRecentItems.slice(0, maxRecentlyViewedItems);
};

export const userFragment = {
    user: graphql`
        fragment getRecentHistory_user on User {
            recentHistoryList {
                eventDate
                item {
                    contemporaryTrackingString
                    firstPhotoWebPath(size: small)
                    pdpURL
                    title
                    browseUrl
                    categoryCode
                    serviceId
                    categoryPath
                    seller {
                        serviceId
                    }
                }
            }
        }
    `,
};
